import { SVGProps } from "react";

const STIEpub = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="ePub" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#FFF" /><path fill="#86b918" d="M256 377L135 256l121-121 40 41-80 80 40 40 121-120L272 70c-9-8-23-8-32 0L70 240c-8 9-8 23 0 32l170 170c9 8 23 8 32 0l170-170c8-9 8-23 0-32l-25-24z" /></svg>;

export { STIEpub };